import * as React from "react"

import _find from "lodash/find"

import {
    Grid,
    GridCell,
    css,
} from "@bdfx/mergado-ui-kit";

import { Palette } from "app/types/model-types";

interface Props {
    close: Function
    addColors: Function
    randomProductColors: string[]
    palettes: Palette[]
    customPalettes: Palette[]
}

class ImportColorsFromPaletteModal extends React.Component<Props> {
    constructor(props) {
        super(props)
    }

    handleAdd = (colors: string[]) => {
        this.props.addColors(colors)
        this.props.close()
    }

    render() {
        const { palettes, customPalettes, randomProductColors } = this.props

        return (
            <StyledDiv>
                {randomProductColors && Array.isArray(randomProductColors) && randomProductColors.length > 0 &&
                    <ColorsGrid onClick={() => this.handleAdd(randomProductColors)} className={'margin-bottom clickable'} title={'product image'}>
                        {randomProductColors.map((color: string, colorIdx: number) => <GridCell
                            key={`k_${color}_${colorIdx}`}
                            style={{ background: color }}
                        />)}
                    </ColorsGrid>
                }

                {customPalettes && customPalettes.length > 0 &&
                    <PalettesGrid cols={'repeat(auto-fit, 400px)'} className={'margin-bottom'}>
                        {customPalettes.map((palette: Palette) => <GridCell key={`h_${palette.id}`} className={'clickable'} onClick={() => this.handleAdd(palette.colors)} title={palette.name}>
                            <ColorsGrid>
                                {palette.colors.map((color: string, colorIdx: number) => <GridCell
                                    key={`j_${color}_${palette.id}_${colorIdx}`}
                                    style={{ background: color }}
                                />)}
                            </ColorsGrid>
                        </GridCell>)
                        }
                    </PalettesGrid>
                }

                {palettes &&
                    <PalettesGrid cols={'repeat(auto-fit, 100px)'}>
                        {palettes.map((palette: Palette, paletteIdx: number) => <GridCell key={`g_${palette.id}`} className={'clickable'} onClick={() => this.handleAdd(palette.colors)} title={`palette ${paletteIdx}`}>
                            <ColorsGrid>
                                {palette.colors.map((color: string, colorIdx: number) => <GridCell
                                    key={`i_${color}_${palette.id}_${colorIdx}`}
                                    style={{ background: color }}
                                />)}
                            </ColorsGrid>
                        </GridCell>)
                        }
                    </PalettesGrid>
                }                
            </StyledDiv>
        )
    }
}

const PalettesGrid = css(Grid)({
    gridGap: '10px',
})

const ColorsGrid = css(Grid)({
    gridTemplateColumns: 'repeat(auto-fit, 25px)',
    gridTemplateRows: '25px',
})

const StyledDiv = css('div')({
    ' .muk-gridcell': {
        textAlign: 'center',
    },
    ' .margin-bottom': {
        marginBottom: '40px',
    },
})

export default ImportColorsFromPaletteModal
